<template>
  <div>
    <v-data-table
      :items="chats"
      item-value="groupChatId" :headers="headers"
      hide-default-footer
      no-data-text="データはありません"
      :loading="loading"
      color="primary"
    >
      <template v-slot:item.chatReadCount="{ item }">
        {{ item.chatReadCount + '人' }}
      </template>

      <template v-slot:item.edit="{ item }">
        <v-btn
          @click="clickItem(item)"
          color="primary"
          variant="flat"
          size="small" 
        >詳細
        </v-btn>
      </template>

      <template v-slot:item.delete="{ item }">
        <v-btn
          @click="clickDelete(item)"
          color="error"
          variant="outlined"
          size="small"
        >削除
        </v-btn>
      </template>

    </v-data-table>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'MailTableContainer',
  
  props: {
    chats: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  // ⭕️ 修正5: emitするイベントを明示
  emits: ['click', 'delete'],

  data() {
    return {
      headers: [
        { title: '日時', key: 'date', }, { title: 'タイトル', key: 'title', },
        { title: '既読', key: 'chatReadCount', },
        { title: '詳細', key: 'edit', sortable: false }, { title: '削除', key: 'delete', sortable: false },
      ],
    }
  },

  methods: {
    clickItem(item: any) {
      this.$emit('click', item);
    },
    clickDelete(item: any) {
      this.$emit('delete', item);
    },
  }
})
</script>